import gql from 'graphql-tag';
import { mutation } from 'services/graphql';
import { surfaceUnionFragment } from 'graphql/surface-node/fragments/surface-node-fragment/surface-node-union-fragment';

export const updateSurfaceBackgroundNodeMutation = gql`
  mutation updateSurfaceBackgroundNode($input: UpdateSurfaceBackgroundNodeInput!) {
    updateSurfaceBackgroundNode(input: $input) {
      success
      error
      data {
        ...surfaceNodeUnionDetails
      }
    }
  }
  ${surfaceUnionFragment}
`;

export default mutation(updateSurfaceBackgroundNodeMutation);
